module.exports = __webpack_public_path__ + "media/assets/icons/reject-4f52f09f19e8c605af8c99737a9f5b74.svg";